let uurll;

if(config.requestSecret=='online'){
    uurll = '68747470733a2f2f7777772e787a6a78726c2e636f6d2f6170692f';
}else if(config.requestSecret=='Offline'){
//    uurll = '687474703A2F2F3139322E3136382E302E38383A35303030312F';//刘
   uurll = '687474703A2F2F3139322E3136382E302E323A353030322F6170692F';//0.2
}


const uint8Array = Uint8Array.from(uurll .match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
const decoder = new TextDecoder();
const str = decoder.decode(uint8Array);


const BaseUrl =str

export default BaseUrl;  

